(function($) {
$(document).ready(function () {
  // Some times you get random p tags that create space

  $('p:empty').remove();

  $('p').each(function() {
    var $this = $(this);
    if ($this.html().replace(/\s|&nbsp;/g, '').length == 0)
      $this.remove();
  });


    // Active Class on Nav
	$(function($) {
	  var path = window.location.href; // because the 'href' property of the DOM element is the absolute path
	  console.log(path)
	  $('.navigation li a').each(function() {
	    if (this.href === path) {
	      $(this).addClass('active');
	    }
	  });
	  // For single posts losing scope
	  if (window.location.href.indexOf('guidance') > 0) {
	    $(".guidance").find(".parent_link").addClass('active');
	  }
	});


	
   // Accordion 
  $(".tab_inner").on("click", function() {
    //console.log("Clicked tab");
    $(this).next(".content").toggleClass("active");
    $(this).toggleClass("active");  
    $(this).find(".arrow").toggleClass("turn_arrow");  
  });



});
})(jQuery); 



